import useTheme from "../../../../common/hooks/useTheme";
import React, { CSSProperties } from "react";

const BarInner = ({ val, maxVal }: { val: number; maxVal: number }) => {
  const theme = useTheme();

  let barInnerHeight, barInnerType;

  if (maxVal === 0 && val > 0) {
    barInnerHeight = "100%";
    barInnerType = "isAboveAverage";
  } else if ((val * 100) / maxVal > 100) {
    barInnerHeight = "100%";
    barInnerType = "isOverTarget";
  } else if ((val * 100) / maxVal <= 100 && (val * 100) / maxVal > 50) {
    barInnerHeight = `${(val * 100) / maxVal}%`;
    barInnerType = "isAboveAverage";
  } else {
    barInnerHeight = `${(val * 100) / maxVal}%`;
    barInnerType = "lowValue";
  }

  return <div style={styles.barInner(theme, barInnerHeight, barInnerType)} />;
};

const ItemCardHomeVerticalBar = ({
  item,
  cardRef,
}: {
  item: any;
  cardRef: any;
}) => {
  const theme = useTheme();
  return (
    <div key={item.label} style={styles.micronutrientCard(theme)} ref={cardRef}>
      <div style={styles.barContainer(theme)}>
        <BarInner val={item.value} maxVal={item.maxValue} />
      </div>
      <div style={styles.cardDetailsContainer}>
        <div style={styles.barValue(theme)}>
          {item.maxValue === 0
            ? item.value === 0
              ? "0%"
              : "--%"
            : `${Math.round((item.value * 100) / item.maxValue)}%`}
        </div>
        <div style={styles.label(theme)}>{item.label}</div>
        <div>
          <span style={styles.value(theme)}>{`${Math.round(
            item.value
          )} /`}</span>
          <span style={styles.maxValue(theme)}>{` ${Math.round(
            item.maxValue
          )} ${item.unit}`}</span>
        </div>
      </div>
    </div>
  );
};

export default ItemCardHomeVerticalBar;

// Styles
const styles = {
  micronutrientCard: (theme: any) => ({
    minWidth: "126px",
    height: "96px",
    backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
    borderRadius: "8px",
    margin: "16px 8px 40px 0",
    padding: "8px",
    display: "flex",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
  }),
  barContainer: (theme: any) => ({
    width: "7px",
    height: "100%",
    backgroundColor: theme.colorTokens.P[10],
    borderRadius: "8px",
    overflow: "hidden",
    display: "flex",
    alignItems: "flex-end",
    marginRight: "8px",
  }),
  cardDetailsContainer: {
    display: "flex",
    flexDirection: "column" as "column",
    justifyContent: "space-between",
  },
  barValue: (theme: any) => ({
    fontFamily: "var(--font-Bold)",
    fontSize: "14px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  label: (theme: any) => ({
    fontFamily: "var(--font-Regular)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_STRONG,
  }),
  valueContainer: {
    display: "flex",
  },
  value: (theme: any) => ({
    fontFamily: "var(--font-Bold)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  maxValue: (theme: any) => ({
    fontFamily: "var(--font-Regular)",
    fontSize: "12px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
  barInner: (theme: any, customHeight: string, type: string) => ({
    height: customHeight,
    width: "6px",
    borderRadius: "38px",
    background:
      type === "isOverTarget"
        ? `linear-gradient(to top, ${theme.colorTokens.P[60]}, ${theme.colorTokens.P[90]}, ${theme.colorTokens.D[60]})`
        : type === "isAboveAverage"
        ? `linear-gradient(to top, ${theme.colorTokens.P[60]}, ${theme.colorTokens.P[90]})`
        : theme.colorTokens.P[60],
  }),
};
